// TODO: Change dr-activities-terms to use this
export const PAYMENT_TERMS_AFFECTED_MONTHS = 'PAYMENT_TERMS_AFFECTED_MONTHS';
